import { Application } from "@hotwired/stimulus"

declare global {
  interface Window {
    Stimulus: Application
  }
}

if (!window.Stimulus) {
  window.Stimulus = Application.start()
}

const application = window.Stimulus

export { application }
